import React, { useState }  from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { v1 as uuidv1 } from 'uuid';

import './NewLane.css';
import { useI18n } from '../../../../i18n';

const stopBubble = (event) => {
    if (event && event.stopPropagation) event.stopPropagation();
};

const NewLane = props => {
    const { t } = useI18n();
    const [lane, setLane] = useState('');

    const cancelLane = e => {
        stopBubble(e);
        if (e && e.preventDefault) e.preventDefault();
        props.onCancel(e);
      }

    const addLane = e => {
        stopBubble(e);
        if (e && e.preventDefault) e.preventDefault();
        const title = (lane || '').trim();
        if (!title) return;
        props.onAdd({
            id: uuidv1(),
            title,
            cards: []
        });
      }

    return (
      <div className="NewLane" onMouseDown={stopBubble} onClick={stopBubble}>
        <Form.Control
            as="input"
            value={lane}
            placeholder={t('board.listName')}
            autoFocus
            onChange={e => setLane(e.target.value)}
            onKeyDown={e => {
                if (e.key === 'Enter') addLane(e);
            }}
            type="text"
        />
        <div className="NewLane-actions">
            <Button type="button" variant="primary" size="sm" onClick={addLane}>{t('board.addLane')}</Button>
            <Button type="button" variant="secondary" size="sm" onClick={cancelLane}>{t('common.cancel')}</Button>
        </div>
      </div>
    )
  }

export default NewLane;
